import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table'
import { Helmet } from "react-helmet";
import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'

function Phome(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
 
return(
    <div>
<Sides/>
<Helmet>
 
<title>Learn Free Python History Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python history tutorial for beginners CodeExampler and Python is a powerful high-level object-oriented language programming language created by Guido Van Rossum" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python history,python introduction tutorial" />
<link rel="canonical" href="https://www.codeexampler.com/python-history" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1"> Python History</h1>

    <div className="first">
       
    <a href="/python-exception-handling">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        </div>

    <p className="mt-4 para">Python is a powerful high-level object-oriented language programming language created by Guido Van Rossum.<br/>
     Python was conceived in the late 1980s in the Netherlands and released in February 1991.<br/> 
     Python language executes on multiple platforms like Mac, Windows, Linux, Unix, Etc. <br/>
     Python first version launched in Jan 1994.
    </p>
    <Table  striped bordered hover responsive variant="dark" className="m-4">
  <thead>
    <tr>
      <th></th>
      <th colSpan="1">Python Versions</th>
      <th>Python Versions release date</th>
   
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Python 1.0</td>
      <td>January 1994</td>
    </tr>
    <tr>
      <td>2</td>
      <td>Python 1.5</td>
      <td>December 31, 1997</td>
     
    </tr>
    <tr>
      <td>3</td>
      <td>Python1.6</td>
      <td>September 5, 2000</td>
     
    </tr>
    <tr>
      <td>4</td>
      <td>Python2.0</td>
      <td>October 16, 2000</td>
     
    </tr>
  </tbody>
</Table>

<h2 className="mt-4 mh2">And at this time, The latest Version is That.</h2>

<Table striped bordered hover responsive variant="dark" className="m-4">

  <tbody>
    <tr>
      <td>3.2</td>
      <td>3.2.6</td>
      <td>2016-02-20</td>
    </tr>
    <tr>
      <td>3.3</td>
      <td>3.3.7</td>
      <td>2017-09-29</td>
     
    </tr>
    <tr>
      <td>3.4</td>
      <td>3.4.10</td>
      <td>2019-03-18</td>
     
    </tr>
    <tr>
      <td>3.5</td>
      <td>3.5.9</td>
      <td>2020-09-13</td>
     
    </tr>
  </tbody>
</Table>
    
  <h1 className="mt-5">  </h1>
       
  <div className="back">
       
  <a href="/python-exception-handling">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        </div>
    </div></div>
)

}
export default Phome;